export default {
  CONTENT_STORE_ID: 'mgnl_contentStoreId',
  TEMPLATE_ANNOTATIONS_STORE_ID: 'mgnl_templateAnnotationsStoreId',
  CONFIG_STORE_ID: 'mgnl_configStoreId',
  MGNL_CONTEXT_STORE_ID: 'mgnl_contextStoreId',
};
